export default class ModalIllust {
    constructor() {
        this.init();
    }

    init() {
        this.modal = document.querySelector('.js-illustmodal');

        if (this.modal) {
            this.showImg();
        }
    }

    showImg() {
        const openbuttons = [...document.querySelectorAll('.js-illustmodal_open')];
        const closebuttons = [...document.querySelectorAll('.js-illustmodal_close')];
        const img = this.modal.querySelector('.js-illustmodal_img');

        openbuttons.forEach((el) => {
            el.addEventListener('click', () => {
                const imgdom = el.querySelector('.js-illustmodal_img');
                const imgpath = imgdom.getAttribute('src');

                img.setAttribute('src', imgpath);

                this.modal.classList.add('-active');
                document.body.classList.add('-inmodal');
            });
        });

        closebuttons.forEach((el) => {
            el.addEventListener('click', () => {
                img.setAttribute('src', '');
                this.modal.classList.remove('-active');
                document.body.classList.remove('-inmodal');

                const activeModal = document.querySelector('.js-illustmodal.-active');
                if (!activeModal) {
                    document.body.classList.remove('-inmodal');
                }
            });
        });
    }
}
